import { Model } from "@vuex-orm/core";
import Powder from "./Powder";
import Manufacturer from "./Manufacturer";
import Supplier from "./Supplier";
import { required, maxLength, decimal } from "vuelidate/lib/validators";
import RawMaterial from "./RawMaterial";
import { MaterialAttachment } from "./Attachment";

export default class Material extends Model {
  static entity = 'materials';

  static $fetchActive() {
    return this.api().get('Materials/?archived=false')
  }
  static $fetchAll() {
    return this.api().get('Materials/')
  }
  static $get (id) {
    return this.api().get(`Materials/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Materials/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Materials/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`Materials/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      notes: this.string(""),
      supplier_id: this.attr(null),
      supplier: this.belongsTo(Supplier, "supplier_id"),
      supplierIcon: this.string("fas fa-shopping-basket"),
      powder_id: this.attr(null),
      powder: this.belongsTo(Powder, "powder_id"),
      powderIcon: this.string("fas fa-shapes"),
      manufacturer_id: this.attr(null),
      manufacturerIcon: this.string("fas fa-industry"),
      manufacturer: this.belongsTo(Manufacturer, "manufacturer_id"),
      name: this.string("Material"),
      icon: this.string("fas fa-globe"),
      hint: this.string("Unique name for the material class"),
      counter: this.number(128),
      color: this.string("blue darken-4"),
      label: this.string("Material"),
      customersupplied: this.boolean(false),
      customersuppliedIcon: this.string("fas fa-handshake"),
      surfacearea: this.string(""),
      surfaceareaIcon: this.string("fas fa-layer-group"),
      bulkdensity: this.string(""),
      bulkdensityIcon: this.string("fas fa-fill"),
      size: this.string(""),
      sizeIcon: this.string("fas fa-braille"),
      moisture: this.string(""),
      moistureIcon: this.string("fas fa-cloud-rain"),
      created: this.string(""),
      archived: this.boolean(false),
      children: this.hasMany(RawMaterial, "material_id"),
      attachments: this.hasMany(MaterialAttachment, "material_id")
    };
  }

  toCreatePayload() {
    return {
      name: this.name,
      supplier: this.supplier_id,
      powder: this.powder_id,
      manufacturer: this.manufacturer_id,
      customersupplied: this.customersupplied,
      surfacearea: this.surfacearea,
      bulkdensity: this.bulkdensity,
      size: this.size,
      moisture: this.moisture,
      notes: this.notes,
      archived: this.archived
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  get createdDate() {
    return new Date(this.created).toDateString();
  }

  get display_name() {
    return `${this.id} - ${this.name}`;
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(128) },
        supplier_id: { required },
        manufacturer_id: { required },
        powder_id: { required },
        surfacearea: { maxLength: maxLength(9), decimal, required },
        bulkdensity: { maxLength: maxLength(9), decimal, required },
        size: { maxLength: maxLength(9), decimal, required },
        moisture: { maxLength: maxLength(9), decimal, required }
      }
    };
  }
}
